import type {AmplitudeOfferPromotionLocation} from "../../../promotion/tracking/get_amplitude_offer_promotion_event_properties";
import type {IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";

export type AmplitudeLeadFormLocation =
    | AmplitudeOfferPromotionLocation
    | "listing_page"
    | "homepage_banner"
    | "rp_multilead_review"
    | "rp_multilead_post_lead"
    | "vendor_page"
    | "property_configurator"
    | "map_list_view";

export const getAmplitudeFormLocation = (leadData: IAmplitudeLeadFormProductData | undefined, preferredLocation?: string): AmplitudeLeadFormLocation => {
    if (
        preferredLocation === "investment_page" ||
        preferredLocation === "property_page" ||
        preferredLocation === "listing_page" ||
        preferredLocation === "rp_multilead_review" ||
        preferredLocation === "rp_multilead_post_lead" ||
        preferredLocation === "vendor_page" ||
        preferredLocation === "property_configurator" ||
        preferredLocation === "map_list_view"
    ) {
        return preferredLocation;
    }

    if (leadData?.property?.detail) {
        return "property_page";
    }

    return "investment_page";
};
import type {AmplitudeOfferPromotionLocation} from "../../../promotion/tracking/get_amplitude_offer_promotion_event_properties";
import type {IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";

export type AmplitudeLeadFormLocation =
    | AmplitudeOfferPromotionLocation
    | "listing_page"
    | "homepage_banner"
    | "rp_multilead_review"
    | "rp_multilead_post_lead"
    | "vendor_page"
    | "property_configurator"
    | "map_list_view";

export const getAmplitudeFormLocation = (leadData: IAmplitudeLeadFormProductData | undefined, preferredLocation?: string): AmplitudeLeadFormLocation => {
    if (
        preferredLocation === "investment_page" ||
        preferredLocation === "property_page" ||
        preferredLocation === "listing_page" ||
        preferredLocation === "rp_multilead_review" ||
        preferredLocation === "rp_multilead_post_lead" ||
        preferredLocation === "vendor_page" ||
        preferredLocation === "property_configurator" ||
        preferredLocation === "map_list_view"
    ) {
        return preferredLocation;
    }

    if (leadData?.property?.detail) {
        return "property_page";
    }

    return "investment_page";
};
